module.exports = __webpack_public_path__ + "img/right-drawn-arrow.3cec0f9f.svg";